import { render, staticRenderFns } from "./PanelTemperatures.vue?vue&type=template&id=49ccc594&lang=pug&"
import script from "./PanelTemperatures.vue?vue&type=script&lang=js&"
export * from "./PanelTemperatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports